import ServiceCard from '../molecules/ServiceCard';
import React from 'react';

import ChatMessageInput from '../atoms/ChatMessageInput';
import ChatConversation from '../molecules/ChatConversation';

interface Props {
}

const Home: React.FC<Props> = (props) => {
    return (
        <div className="flex !justify-end flex-col h-full">
            <ChatConversation />
            <ChatMessageInput />
        </div>
    );
};

export default Home;